import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { appTitlePwa_template } from "./appTitlePwa_template";
import { brandSelectorPwa_template } from "./brandSelectorPwa_template";
import { userSectionPwa_template } from "./userSectionPwa_template";
//import {sampleSection_template} from "./sampleSection_template";
import { menu_collapsible_pwa_template } from "./menu_collapsible_pwa_template";

declare var ko: any;
export class menuNavPwa_template extends vnTemplate {

    protected appTitle: appTitlePwa_template;
    protected brandSelector: brandSelectorPwa_template;
    protected userSection: userSectionPwa_template;
    protected menuTemplate: menu_collapsible_pwa_template;
    //protected sampleSection : sampleSection_template

    protected getTemplateHtml(): string {

        return this.appTitle.getHtmlBuild() +
            this.brandSelector.getHtmlBuild() +
            this.userSection.getHtmlBuild() +
            this.menuTemplate.getHtmlBuild();
    }

    protected initPartial(): void {

        this.appTitle = new appTitlePwa_template("appTitle", this.getTemplateViewModel(), this.caller);
        this.appTitle.setTitle("emakicms");

        this.brandSelector = new brandSelectorPwa_template("brandSelector", this.getTemplateViewModel(), this.caller);
        this.brandSelector.setSelected({ id: 0, name: "-select property-" });

        this.userSection = new userSectionPwa_template("userHeader", this.getTemplateViewModel(), this.caller);

        this.menuTemplate = new menu_collapsible_pwa_template("mainNavMenu", this.getTemplateViewModel(), this.caller);

        //this.sampleSection = new sampleSection_template("sampleSection", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "menuNav-template";
    }
    protected getMainElementType(): string {
        return "nav";
    }
    protected getMainElementClasses(): Array<string> {
        return ["main-nav"];
    }

    protected buildViewModel(): any {

        return {
            user: ko.observable(null),
            menuItems: ko.observableArray([])

        };
    }

    public disableUserLink() {

        this.userSection.setIsUserLinkDisabled(true);
    }

    public disableEmakiLink() {

        this.appTitle.setIsLinkDisabled(true);
    }


    public changeSelection(idSelected) {

        this.caller.changeSelection(idSelected);
    }

    /*
    menuClick(data, event){
        for( let m of this.viewModel[this.idElement].menus()){
            m.selected(false);
        }
        data.selected(true);
        return true;
    }
    */
    setMenus(menus: Array<{ id: number, text: string, url: string, subMenus: Array<{ text: string, url: string }>, cssClass: Array<string> }>): void {
        this.menuTemplate.setMenus(menus);
    }

    //
    // set the user display
    setUser(user: any) {
        this.userSection.setUser(user);
        //this.sampleSection.setUser(user);
    }

    //
    // set and select the brand drop down menu
    setBrands(brands: any) {
        this.brandSelector.setItems(brands);
        this.userSection.setBrands(brands)
    }
    setSelectedBrand(idBrand: number) {
        this.brandSelector.setSelectedById(idBrand);
    }

    getSelectedBrand(): number {
        return this.brandSelector.getTemplateViewModel().selected();
    }

    public setMenuItems(menuItems: Array<Object>): void {
        this.getTemplateViewModel().menuItems(menuItems);
    }

    public setDefaultSectionId(sectionId): void {
        window.localStorage.setItem('defaultBrandMenuSection', sectionId);
    }
    public getDefaultSectionId() {
        return window.localStorage.getItem('defaultBrandMenuSection');
    }

    public getMenus() {
        return this.menuTemplate.getMenus();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/menuNavPwa_template.ts